<template>
  <el-footer>
    <div class="footer">
      <div class="content">
        <div class="item">
          <div class="title">关于我们</div>
          <div v-for="(x,i) in navList" :key="i"><a  style="color:#fff;text-decoration:none" :href="x.url" target="" >{{x.name}}</a></div>
        </div>
        <div class="item">
          <div class="title">专业领域</div>
          <el-row style="display:flex">
            <div v-for="(x,i) in Professionalfield" :key="i">{{x.name}}</div>
          </el-row>
        </div>
        <div class="item Contact_us">
          <div class="title">联系我们</div>
          <div class="item-option">
            <div class="item-option-tit">邮件地址</div>
            <div class="item-option-tit">{{ContactUs.email}}</div>
          </div>
          <div class="item-option">
            <div class="item-option-tit">法律咨询电话</div>
            <div class="item-option-tit">{{ContactUs.fax}}</div>
          </div>
          <!-- <div class="item-option">
            <div class="item-option-tit">法律咨询电话</div>
            <div class="item-option-tit">{{ContactUs.lawServiceTel}}</div>
          </div> -->
          <div class="item-option">
            <div class="item-option-tit">律所地址</div>
            <div class="item-option-tit">{{ContactUs.address}}</div>
          </div>
           <div class="item-option">
            <div class="item-option-tit">总部地址</div>
            <div class="item-option-tit">北京市朝阳区金和东路20号院正大中心2号楼19-25层</div>
          </div>
        </div>
        <div class="item Rcode">
          <!-- <div class="col-6">
            <div class="Rcode-tit">盈科苏州官方微博</div>
            <div class="Rcode-text">盈科苏州官方微博</div>
            <div class="Rcode-img">
              <img :src="Url.imgUrl+SystemOption.weiBoQrCode" :alt="SystemOption.seoKeyWord" />
            </div>
          </div> -->
          <div class="col-6">
            <div class="Rcode-tit">盈科苏州官方微信</div>
            <div class="Rcode-text">盈科苏州官方微信</div>
            <div class="Rcode-img">
              <img :src="Url.imgUrl+SystemOption.weChatQrCode" :alt="SystemOption.seoKeyWord" />
            </div>
          </div>
        </div>
        <div class="item link">
          <div class="title">友情链接</div>
          <div class="link-box">
            <div ><a style="color:#fff" target="_blank" href="http://www.yingkelawyer.com" >盈科总部</a></div>
            <div ><a style="color:#fff" target="_blank" href="http://www.moj.gov.cn/" >中华人民共和国司法部</a></div>
            <div ><a style="color:#fff" target="_blank" href="http://www.court.gov.cn/" >中华人民共和国最高人民法院</a></div>
            <div ><a style="color:#fff" target="_blank" href="https://www.spp.gov.cn/" >中华人民共和国最高人民检察院</a></div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="CopyrightTipS">盈科律师事务所版权所有 COPYRIGHT 2020 YINGKE LAW FIRM ALL RIGHTS RESERVED. <a href="http://beian.miit.gov.cn" style="color: #bd9d6c;">粤ICP备17043658号-3</a></div>
  </el-footer>
</template>

<script>
export default {
  data() {
    return {
      navList:[],
      Professionalfield:[],
      ContactUs:[],
      SystemOption:[],
      SeoLinks:[],

    };
  },
  mounted() {
    // 关于我们
    this.axios.get(this.Url.apiUrl + "SeoLinks/GetAboutUsList").then((res) => { this.navList = res.data.data; });
    //获取专业领域
    this.axios({ type: "get", url: this.Url.apiUrl + "ProfessionalField/GetProfessionalField", }).then((res) => {this.Professionalfield = res.data});
    // logo、邮件地址、电话、地址
    this.axios.get(this.Url.apiUrl+"ContactUs").then(res => this.ContactUs = res.data);
    //获取SEO配置
    this.axios.get(this.Url.apiUrl+"SystemOption/GetSystemOption").then(res => {this.SystemOption = res.data; this.$store.state.guid = res.data.guid});
    
  },
};
</script>

<style lang="scss" scoped>
.el-footer {
  position: relative;
  height: 412px !important;
  width: 100%;
  background: url("../assets/footer/footerbg.png");
  background-size: 100% 100%;
  @media screen and (max-width: 1800px) {
      height: 420px !important;
  }
  @media screen and (max-width: 768px) {
    height: auto !important;
  }
  .footer {
    position: relative;
    height: 325px;
    padding: 38px 0 32px 0;
    border-bottom: 1px solid #3b4247;
    @media screen and (max-width: 1800px) {
      height: auto !important;
    }
    @media screen and (max-width: 768px) {
      padding: 20px 0 20px 0;
      height: auto !important;
    }
    .content {
      display: flex;
      width: 1400px;
      height: 100%;
      margin: 0 auto;
      overflow: hidden;
      justify-content: space-around;
      @media screen and (max-width: 1800px) {
         width: 1200px;
      }
      @media screen and (max-width: 768px) {
        width: 1300px;
      }
      @media screen and (max-width: 768px) {
        display: block;
        width: 100%;
        padding: 20px 0 20px 0;
        height: auto !important;
      }
      .item {
        display: block;
        min-width: 100px;
        border-right: 1px solid #4e4e4e;
        color: #ffffff;
        text-align: left;
        padding: 0 22px;
        font-size: 12px;
        &:last-child{
          border-right: 0;
        }
        @media screen and (max-width: 1300px) {
          padding: 0 9px;
        }
        @media screen and (max-width: 768px) {
          display: flex;
          flex-wrap: wrap;
          border-right: none;
        }
        div {
          line-height: 30px;
          @media screen and (max-width: 768px) {
            flex: 0 0 25%;
            line-height: auto;
          }
        }
        .title {
          color: #bd9d6c;
          padding-bottom: 10px;
          font-size: 16px;
          white-space: nowrap;
          @media screen and (max-width: 768px) {
            flex: 0 0 100%;
          }
        }
        .el-row {
          
          display: flex;
          justify-content: space-around;
          align-items: center;
          flex-wrap: wrap;
          width: 380px;
          @media screen and (max-width: 768px) {
            flex: 0 0 100%;
          }
          div {
            flex: 0 0 50%;
            @media screen and (max-width: 768px) {
              flex: 0 0 50%;
            }
          }
          div:last-of-type {
            flex: auto;
          }
        }
        .item-option {
          position: relative;
          display: flex;
          width: 100%;
          .item-option-tit:nth-of-type(even) {
            display: block;
            flex: 0 0 60%;
          }
          .item-option-tit:nth-of-type(odd) {
            display: block;
            flex: 0 0 40%;
          }
        }
      }
      .Contact_us {
        @media screen {
          .item-option {
            flex: 0 0 100%;
            position: relative;
            display: flex;
            width: 100%;
            .item-option-tit:nth-of-type(even) {
              display: block;
              flex: 0 0 60%;
            }
            .item-option-tit:nth-of-type(odd) {
              display: block;
              flex: 0 0 40%;
            }
          }
        }
      }
      .item.Rcode {
        width: 200px;
        display: flex;
        justify-content: space-between;
        @media screen and (max-width: 768px){
        }
        .col-6 {
          flex: 0 0 100%;
          .Rcode-tit {
            color: #bd9d6c;
            font-size: 16px;
            padding-bottom: 10px;
          }
          .Rcode-text {
            padding-bottom: 10px;
          }
          .Rcode-img {
            width: 140px;
            height: 140px;
            overflow: hidden;
            @media screen and (max-width: 768px){
              width: 140px;
              height: 140px;
            }
            img{
              width: 100%;
            }
          }
        }
      }
      .item.link {
        .link-box {
          background-color: #be9d6d;
          text-align: center;
          width: 140px;
          padding: 0px 5px;
          border-radius: 3px;
          @media screen and (max-width: 1300px) {
            width: 110px;
          }
          @media screen and (max-width: 768px) {
            flex: 0 0 100%;
            width: 100%;
            display: flex;
            flex-wrap: wrap;
            text-overflow: ellipsis;
            align-items: center;
          
            div {
              flex: 0 0 25%;
              line-height: 20px;
              line-height: 30px;
              margin: 0 2px;
            }
              div:first-of-type{
              flex: 0 0 19%;
              
            }
          }
        }
      }
    }
    .CopyrightTips {
      position: absolute;
      bottom: 20px;
    }
  }
  .CopyrightTipS {
    display: block;
    width: 100%;
    height: 86px;
    color: #bd9d6c;
    font-size: 18px;
    text-align: center;
    line-height: 86px;
    overflow: hidden;
    @media screen and (max-width: 768px) {
      font-size: 10px;
      height: auto;
      line-height: 20px;
      padding: 10px 42px;
    }
  }
}
</style>